import { render, staticRenderFns } from "./NotificationKindBadge.vue?vue&type=template&id=6c323ee4&scoped=true"
import script from "./NotificationKindBadge.vue?vue&type=script&lang=js"
export * from "./NotificationKindBadge.vue?vue&type=script&lang=js"
import style0 from "./NotificationKindBadge.vue?vue&type=style&index=0&id=6c323ee4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c323ee4",
  null
  
)

export default component.exports